// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/7fbd0bd5/" + chunkId + "." + __webpack_require__.h() + ".v7fbd0bd5.js";
};